import { ButtonPest } from '../../../../../utils/Button';

function BillingRow({ openModal, invoiceData }) {
    return (
        <div>
            <div className="mb-4">
                <h2 className="text-primary text-xl font-normal">Billing</h2>
            </div>
            <span>
                <ButtonPest
                    title="Receive Payment"
                    onClick={() => openModal('payment-receive')}
                    disabled={invoiceData?.amountDue === 0 || invoiceData?.status === 'canceled'}
                />
            </span>
        </div>
    );
}

export default BillingRow;
